// HARIO-CUSTOM: ada-video-aria-label-and-pause-control
//
// WCAG 1.2.1 (Audio-only/Video-only Prerecorded) + 2.2.2 (Pause Stop Hide)
//
// Theme renders decorative loop videos on homepage / sections without
// aria-label or pause control. This module:
//   1) Sets aria-label on each autoplay <video> so screen readers identify it
//      ("Decorative product showcase video, no audio").
//   2) Injects a small pause / play button overlay (.ada-video-pause) so
//      users can stop motion that lasts > 5 seconds (2.2.2 requirement).
//   3) Auto-pauses videos when user has `prefers-reduced-motion: reduce`.
//
// Re-runs on DOM mutations because section-rendering APIs can inject videos
// after initial load.

(function () {
  'use strict';

  var ADA_LABEL = 'Decorative product showcase video, no audio';

  function ensureAriaLabel(video) {
    if (!video.getAttribute('aria-label') && !video.getAttribute('aria-labelledby')) {
      video.setAttribute('aria-label', ADA_LABEL);
    }
  }

  function svgPause() {
    return (
      '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<rect x="3" y="2" width="3.5" height="12" fill="currentColor"/>' +
      '<rect x="9.5" y="2" width="3.5" height="12" fill="currentColor"/>' +
      '</svg>'
    );
  }
  function svgPlay() {
    return (
      '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<polygon points="3,2 13,8 3,14" fill="currentColor"/>' +
      '</svg>'
    );
  }

  function attachPauseButton(video) {
    if (video.dataset.adaPauseAdded === '1') return;
    if (video.controls) {
      // Native controls already satisfy 2.2.2 — no need to inject our own.
      video.dataset.adaPauseAdded = '1';
      return;
    }
    var wrap = video.parentElement;
    if (!wrap) return;
    var cs = window.getComputedStyle(wrap);
    if (cs.position === 'static') wrap.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ada-video-pause';
    btn.setAttribute('aria-label', 'Pause background video');
    btn.innerHTML = svgPause();

    function syncButton() {
      if (video.paused) {
        btn.setAttribute('aria-label', 'Play background video');
        btn.innerHTML = svgPlay();
      } else {
        btn.setAttribute('aria-label', 'Pause background video');
        btn.innerHTML = svgPause();
      }
    }

    btn.addEventListener('click', function (e) {
      // Several theme sections wrap the <video> in an <a> (link block).
      // Without stopPropagation, clicking the pause button would also trigger
      // the parent anchor's navigation. preventDefault() alone is not enough
      // here because the anchor is an ancestor of the button.
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.pause();
      }
      syncButton();
    });
    video.addEventListener('play', syncButton);
    video.addEventListener('pause', syncButton);

    wrap.appendChild(btn);
    video.dataset.adaPauseAdded = '1';
  }

  function processVideos() {
    var reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var videos = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      ensureAriaLabel(v);
      if (reduceMotion && !v.dataset.adaReducedHandled) {
        try {
          v.pause();
        } catch (e) {
          // ignore — some videos are not yet loaded
        }
        v.dataset.adaReducedHandled = '1';
      }
      attachPauseButton(v);
    }
  }

  function init() {
    processVideos();
    // Sections (e.g. theme editor live preview, dynamic section reorder) can
    // inject new <video> elements after DOMContentLoaded.
    var observer = new MutationObserver(function (mutations) {
      var needsScan = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (
            n.nodeType === 1 &&
            ((n.tagName === 'VIDEO' && n.hasAttribute('autoplay')) ||
              (n.querySelector && n.querySelector('video[autoplay]')))
          ) {
            needsScan = true;
            break;
          }
        }
        if (needsScan) break;
      }
      if (needsScan) processVideos();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// /HARIO-CUSTOM: ada-video-aria-label-and-pause-control
